import React from 'react'
import { useFormContext } from 'react-hook-form'

import SelectInput from '../../shared/Inputs/SelectInput/SelectInput'
import TextInput from '../../shared/Inputs/TextInput/TextInput'

import {
  validateName,
  validateString,
  stringDigitsLength,
} from '../../validate/validators'
import { Country, Lang } from '../../types/common-types'
import { State } from '../../state-actions-reducers'
import CompanyScreenOneRus from './Company/RusRegistration/CompanyScreenOne'
import CompanyScreenOneKzt from './Company/KztRegistration/CompanyScreenOne'
import CompanyScreenOneKgz from './Company/KgzRegistration/CompanyScreenOne'
import IpScreenOneRus from './Individual/RusRegistration/IpScreenOne'
import IpScreenOneKzt from './Individual/KztRegistration/IpScreenOne'
import IpScreenOneKgz from './Individual/KgzRegistration/IpScreenOne'
import IpScreenOneRom from './Individual/RomRegistration/IpScreenOne'
import {
  FiscalTypeValues,
  FiscalTypeValuesKz,
  FiscalTypeValuesRom,
  FiscalTypeValuesKgz,
  IpTypeValuesKz,
} from '../../content/fiscalType'
import styles from './FiscalScreenOne.module.scss'
import InfoMessage from '../../shared/InfoMessage/InfoMessage'

interface Props {
  lang: Lang;
  accountForm: any;
  citizenshipCountriesList: Country[];
  allFiscalCountry: Country[];
  addressCountries: Country[];
  countriesList: Country[];
  regionCityRegistered: any;
  regionCityFactual: any;
  regionCityResidence: any;
  regionCity: any;
}

/* REACT COMPONENT */
function FiscalScreenOne({
  lang,
  accountForm,
  citizenshipCountriesList,
  allFiscalCountry,
  addressCountries,
  regionCityRegistered,
  regionCityFactual,
  regionCityResidence,
  countriesList,
  regionCity,
}: Props) {
  const { watch, setValue, formState: { errors } } = useFormContext<State>()
  const state = watch()
  return (
    <>
      <main className={styles.main}>
        <div className="row">
          <div className="col-12 col-xs-12">
            <h3 className={styles.header}>{accountForm.Fiscal_Region[lang]}</h3>
          </div>
        </div>
        <div className="form-group">
          <div className="row">
            <div className="col-6 col-xs-12">
              {/* REGISTRATION ADDRESS COUNTRY */}
              <SelectInput
                testName={'countryRegistration'}
                testErrorName={'error-countryRegistration'}
                noOptionsMessage={accountForm.citizenshipInput.placeholder}
                lang={lang}
                disabled={!state.agreed}
                content={accountForm.countryRegistration}
                options={allFiscalCountry}
                onChange={id =>
                  setValue('countryRegistration', id, { shouldDirty: true })
                }
                valid={validateString(state.countryRegistration, 3, false)}
                value={state.countryRegistration}
                prefix={state.iframeCountry === '398' ? "Citizenships" : "CitizenshipsRf"}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-xs-12">
            <h3 className={styles.header}>
              {state.F_FiscalType === '1' ? accountForm.Fiscal_Requisites_IP[lang] : accountForm.Fiscal_Requisites[lang]}
            </h3>
          </div>
        </div>
        <div className="row">
          {/* F_FiscalType */}
          <div className="col-4 col-xs-12">
            {state.F_FiscalType !== '1' &&
              <SelectInput
                lang={lang}
                noOptionsMessage={accountForm.noOptionsMessage}
                content={accountForm.F_FiscalType}
                onChange={data => {
                  setValue('F_FiscalType', data, { shouldDirty: true })
                }}
                value={state.F_FiscalType}
                options={
                  state.countryRegistration === '398'
                    ? state.F_FiscalType === '1' ? IpTypeValuesKz : FiscalTypeValuesKz
                    : state.countryRegistration === '417'
                      ? FiscalTypeValuesKgz
                      : state.countryRegistration === '642'
                        ? FiscalTypeValuesRom
                        : FiscalTypeValues
                }
                valid={
                  !errors.F_FiscalType &&
                  validateName(state.F_FiscalType)
                }
                className={styles.inputl}
              />
            }
          </div>
          {(state.countryRegistration === '643' && state.F_FiscalType !== '1') && <><div className="col-2 col-xs-12">
            <TextInput
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.F_INN}
              onChange={F_INN => {
                setValue('F_INN', F_INN.replace(/\D/gim, '').substr(0, 10), { shouldDirty: true })
              }}
              value={state.F_INN || ''}
              required
              valid={
                stringDigitsLength(state.F_INN, 10, false) &&
                !errors.F_INN
              }
              mask={'9999999999'}
            />
          </div>
            <div className="col-2 col-xs-12">
              <TextInput
                disabled={!state.agreed}
                lang={lang}
                content={accountForm.F_KPP}
                onChange={F_KPP => {
                  setValue('F_KPP', F_KPP.replace(/\D/gim, '').substr(0, 9), { shouldDirty: true })
                }}
                value={state.F_KPP || ''}
                required
                valid={
                  stringDigitsLength(state.F_KPP, 9, false) &&
                  !errors.F_KPP
                }
                mask={'999999999'}
              />
            </div>
            <div className="col-12 col-xs-12">
              {state.F_INN.length < 10 && <InfoMessage type={"default"} text={<>
                <span>{accountForm.organizationsAutoFill[lang]}</span>
              </>} />}
            </div>
          </>}
        </div>
        {state.F_FiscalType !== '1' ? (
          // Казахстан
          state.countryRegistration === '398' ? (
            <CompanyScreenOneKzt
              lang={lang}
              
              accountForm={accountForm}
              addressCountries={addressCountries}
              regionCityRegistered={regionCityRegistered}
              regionCityFactual={regionCityFactual}
            />
          ) : //Киргизия
            state.countryRegistration === '417' ||
              state.countryRegistration === '642' ? (
              <CompanyScreenOneKgz
                lang={lang}
                
                accountForm={accountForm}
                addressCountries={addressCountries}
                regionCityRegistered={regionCityRegistered}
                regionCityFactual={regionCityFactual}
              />
            ) : (
              <CompanyScreenOneRus
                lang={lang}
                
                accountForm={accountForm}
                addressCountries={addressCountries}
                regionCityRegistered={regionCityRegistered}
                regionCityFactual={regionCityFactual}
              />
            )
        ) : // Казахстан
          state.countryRegistration === '398' ? (
            <IpScreenOneKzt
              lang={lang}
              
              accountForm={accountForm}
              citizenshipCountriesList={citizenshipCountriesList}
              addressCountries={addressCountries}
              regionCityRegistered={regionCityRegistered}
              regionCityFactual={regionCityFactual}
              regionCityResidence={regionCityResidence}
            />
          ) : // Киргизия
            state.countryRegistration === '417' ? (
              <IpScreenOneKgz
                lang={lang}
                
                accountForm={accountForm}
                citizenshipCountriesList={citizenshipCountriesList}
                addressCountries={addressCountries}
                regionCityRegistered={regionCityRegistered}
                regionCityFactual={regionCityFactual}
                regionCityResidence={regionCityResidence}
              />
            ) : state.countryRegistration === '642' ? (
              <IpScreenOneRom
                lang={lang}
                
                accountForm={accountForm}
                citizenshipCountriesList={citizenshipCountriesList}
                addressCountries={addressCountries}
                regionCityRegistered={regionCityRegistered}
                regionCityFactual={regionCityFactual}
                regionCityResidence={regionCityResidence}
              />
            ) : (
              <IpScreenOneRus
                lang={lang}
                
                accountForm={accountForm}
                citizenshipCountriesList={citizenshipCountriesList}
                addressCountries={addressCountries}
                regionCityRegistered={regionCityRegistered}
                regionCityFactual={regionCityFactual}
                regionCityResidence={regionCityResidence}
              />
            )}
      </main>
    </>
  )
}

export default FiscalScreenOne
